export default __webpack_public_path__ + "static/media/close-button-hover.ec5362e1.png";